{
  "accepted": "Akseptert",
  "acceptTerms": "Aksepter vilkår",
  "accountSettings": "Kontoinnstilinger",
  "active": "Aktiv",
  "active_plural": "Aktive",
  "activity": "Aktivitet",
  "actorsForProgram": "Aktører i {{programName}}- programmet",
  "actorsForProgramDescription": "Liste over aktører i {{programName}}-programmet. Som administrator har du lesetilgang til alt innhold.",
  "add": "Legg til",
  "addComment": "Legg til kommentar",
  "addCost": "Legg til kostnad",
  "addNewRow": "Legg til ny linje",
  "addNote": "Legg til notat",
  "address": "Adresse",
  "advisor": "Rådgiver",
  "all": "Alle",
  "alerts": "Varsler",
  "alreadyExists": "Ekisterer allerede",
  "amount": "Beløp",
  "applicantCompany": "Søkerbedrift",
  "approve": "Godkjenn",
  "approved": "Godkjent",
  "archive": "Arkiv",
  "ariaLabelReportSaveStatusSection": "Sist lagret status",
  "ariaLabelTopMenuSection": "Toppmeny",
  "at": "Hos",
  "attachment": "Vedlegg",
  "attachments": "Vedlegg",
  "back": "Tilbake",
  "background": "Bakgrunn",
  "baseInfo": "Basisinformasjon",
  "baseReport": "Basisrapport",
  "billingAddress": "Fakturaadresse",
  "budget": "Budsjett",
  "businessGarden": "Næringshage",
  "cancel": "Avbryt",
  "cannotBeUndone": "Denne handlingen kan ikke endres.",
  "cannotRead": "Du har ikke leserettigheter til dette.",
  "cannotWrite": "Du har ikke skriverettigheter til dette.",
  "caseNumber": "Saksnummer",
  "category": "Kategori",
  "choose": "Velg",
  "chooseActor": "Velg aktør",
  "chooseCluster": "Velg klynge",
  "chooseClusterChosen": "Valgt nettverk",
  "chooseClusterTitle": "Velg klynge - Flerbedriftsportalen",
  "chooseCounty": "Velg fylke",
  "chooseFiles": "Velg filer",
  "chooseReport": "Velg rapport",
  "chooseMunicipality": "Velg kommune",
  "chooseStatus": "Velg status",
  "chosenActor": "Valgt aktør",
  "close": "Lukk",
  "closeDialog": "Lukk dialog",
  "textArea.charactersLeft": "%d tegn igjen",
  "textArea.charactersOver": "%d tegn for mye",
  "jobTitle": "Stillingstittel",
  "cluster": "Klynge",
  "clusterLeader": "Leder",
  "clusterManager": "Klyngeleder",
  "boardChairman": "Styreleder",
  "boardMember": "Styremedlem",
  "boardVaraMember": "Varamedlem, styre",
  "projectManager": "Prosjektleder",
  "clusterName": "Nettverksnavn",
  "clusterOperation": "Klyngedrift",
  "column": "Kolonne",
  "comment": "Kommentar",
  "commenting": "Kommenter",
  "companies": "Bedrifter",
  "company": "Bedrift",
  "completed": "Fullført",
  "notCompleted": "Ikke fullført",
  "contact": "Kontakt",
  "contactInformation": "Kontaktinformasjon",
  "contactPerson": "Kontaktperson",
  "contactStatus": "Kontaktstatus",
  "contactUsForSolution": "Kontakt oss gjerne for å finne en annen løsning.",
  "continue": "Fortsett",
  "cooperation": "Samarbeid",
  "copyLink": "Kopier lenke",
  "cost": "Kostnad",
  "costs": "Kostnader",
  "costType": "Kostnadstype",
  "costTypes": "Kostnadstyper",
  "costTypeTitle": "Tittel på kostnadstype",
  "count": "Antall",
  "county": "Fylke",
  "course": "Kurs",
  "create": "Opprett",
  "createAttachment": "Opprett vedlegg",
  "created": "Opprettet",
  "createReport": "Opprett rapport",
  "customer": "Kunde",
  "customerInfo": "Kundeinfo",
  "customerInformation": "Kundeinformasjon",
  "date": "Dato",
  "dateNotSet": "Dato ikke satt",
  "default": "Standard",
  "delete": "Slett",
  "deleteSelected": "Slett valgte",
  "deleted": "Slettet",
  "deleting": "Sletter",
  "delivered": "Innsendt",
  "selfDeclarationStatusDeliveredOnDate": "Gyldig til {{date}}",
  "expiresSoon": "Utløper snart",
  "selfDeclarationExpired": "Utløpt",
  "selfDeclarationStatusExpiresOnDate": "Utløper {{date}}",
  "missing": "Mangler",
  "notDelivered": "Ikke innsendt",
  "description": "Beskrivelse",
  "developmentReport": "Utviklingsrapport",
  "done": "Ferdig.",
  "doNotSendEmail": "Ikke send e-post",
  "download": "Last ned",
  "downloading": "Laster ned",
  "downloadAttachment": "Last ned vedlegg",
  "downloadTemplate": "Last ned mal",
  "dragFiles": "eller dra dem hit.",
  "economy": "Økonomi",
  "edit": "Endre",
  "editTabelView": "Rediger tabellvisning",
  "email": "E-post",
  "employee": "Ansatt",
  "emptyList": "Tøm listen",
  "end": "Avslutt",
  "endDate": "Sluttdato",
  "errorAcceptConsent": "Vi beklager! En feil har skjedd internt i våre tjenester. Prøv gjerne en gang til da det kan være en midlertidig feil. Hvis problemet vedvarer, prøv igjen litt senere.",
  "establishmentDate": "Etableringsdato",
  "event": "Event",
  "eventRegistration.completionGratitude": "Takk for at du registrerte deltagelsen din!",
  "eventRegistration.errorRepeat": "Kunne ikke sende inn registrering. Kan du prøve på nytt?",
  "eventRegistration.errorUnavailable": "Oppgitt event er ikke tilgjengelig for registrering.",
  "eventRegistration.formAddCompanyNameOrNumber": "Skriv inn enten bedriftnavn eller nummer. Hvis du ikke finner det i listen som kommer opp kan du la navnet stå.",
  "eventRegistration.formAddContactInfo": "Legg inn kontaktinformasjon",
  "eventRegistration.formAdjustHours": "Justere timer",
  "eventRegistration.formAdjustHoursDescription": "Her kan du føre timer for reisetid og/eller forberedende timer i tillegg til arrangementet. Timer brukt på arrangementet er allerede satt.",
  "eventRegistration.formDescriptionText": "Legg gjerne ved en beskrivelse hvis du endrer tidsbruket. Dette kan være for eksempel på grunn av reisetid, forberedelser eller annet.",
  "eventRegistration.formMyEmail": "Min e-post",
  "eventRegistration.formRegisterHours": "Registrer timer",
  "eventRegistration.formSendRegistration": "Send inn registrering",
  "eventRegistration.formTitle": "Registrer ditt oppmøte",
  "eventRegistration.title": "Eventregistrering",
  "export": "Eksporter",
  "exportToExcel": "Eksporter til Excel",
  "female": "Kvinne",
  "fetching": "Henter...",
  "fetchingEvents": "Henter events...",
  "fetchingHourRate": "Henter timesats...",
  "fetchingProjects": "Henter prosjekter...",
  "fieldIsRequired": "Dette feltet er påkrevd",
  "required": "Må fylles ut",
  "fieldsOfInterest": "Interesseområder",
  "filter": "Filtrer",
  "filterBy": "Filtrer etter",
  "filterLeads": "Filtrer leads",
  "filterMembers": "Filtrer medlemmer",
  "filters": "Filtre",
  "financing": "Finansiering",
  "financingSource": "Finansieringskilde",
  "financingTitleLable": "Tittel på finansiering",
  "firstName": "Fornavn",
  "lastName": "Etternavn",
  "footer.contact": "Ta kontakt",
  "footer.copyright": "Opphavsrett © {{ date }}. Alle rettigheter",
  "footer.questionsAboutPortal": "Spørsmål om flerbedriftsportalen?",
  "from": "Fra",
  "frontpage.alerts.none": "Du har ingen nye varsler.",
  "gender": "Kjønn",
  "goalAchievement": "Måloppnåelse",
  "goBack": "Gå tilbake",
  "gotoAdminStatistics": "Gå til admin statistikk",
  "goToCourse": "Gå til kurs",
  "goToMainPage": "Gå til forsiden",
  "halfYearReports": "Halvårsrapporter",
  "here": "her",
  "hide": "Skjul",
  "historic": "Historikk",
  "history": "Historie",
  "hits": "treff",
  "homeError4XX": "Noe feilet i kommunikasjonen mellom våre tjenester. Vi kunne ikke logge deg inn.",
  "homeError5XX": "Noe feilet internt i våre systemer. Vi kunne ikke logge deg inn.",
  "homeErrorContactLinkPart1": "Får du ikke logget inn i portalen kan du ta kontakt med oss",
  "homeErrorContactLinkPart2": "eller sende oss en mail på flerbedriftsportal@innovasjonnorge.no.",
  "homeErrorNoActors": "Det ser ikke ut til at du er knyttet til en aktør. For å kunne bruke Flerbedriftsportalen må du ha blitt invitert inn av en person hos en aktør som har tilgang. ",
  "homeErrorNotRegistered": "Det ser ut som om brukeren din ikke er registrert. Kontakt en aktør for å få aktiveringslenke.",
  "hours": "Timer",
  "ideas": "Ideer",
  "imported": "Importert",
  "inactive": "Inaktiv",
  "inactive_plural": "Inaktive",
  "incubator": "Inkubator",
  "info": "Info",
  "inCollaboration": "I samarbeid",
  "inCollaborationWith": "I samarbeid med",
  "industry": "Bransje",
  "inkind": "Egeninnsats",
  "innovationNorway": "Innovasjon Norge",
  "inProgress": "I arbeid",
  "international": "Internasjonal",
  "invalid": "Ugyldig",
  "invitationStatus": "Invitasjonsstatus",
  "keep": "Behold",
  "language": "Språk",
  "lastChanged": "Sist endret",
  "link": "Link",
  "linkCopied": "Link kopiert!",
  "invalidValue": "Ugyldig verdi",
  "loading": "Laster",
  "loadingData": "Laster data",
  "loadingAttachments": "Henter vedlegg...",
  "tryAgain": "Prøv på nytt",
  "MulticompanyPortal": "Flerbedriftsportalen",
  "loadingMulticompanyPortal": "Laster inn flerbedriftsportalen...",
  "loadingMulticompanyPortalClusters": "Henter klynger...",
  "loadingMulticompanyPortalPermissions": "Henter tilganger...",
  "loadingMulticompanyPortalRetrievingUser": "Henter bruker...",
  "loadingMulticompanyPortalTitle": "Laster inn flerbedriftsportalen",
  "location": "Lokasjon",
  "logIn": "Logg inn",
  "logInEmployee": "Ansatt i Innovasjon Norge? Klikk her.",
  "logOut": "Logg ut",
  "mailingAddress": "Postadresse",
  "mainGoal": "Hovedmål",
  "mainMenu": "Hovedmeny",
  "header.contact": "Hvordan kan vi hjelpe deg?",
  "maintenanceHeader": "Flerbedriftsportalen er nede for vedlikehold",
  "maintenanceText": "Takk for tolmodigheten. Du kan nå oss på:",
  "male": "Mann",
  "manually": "Manuelt",
  "memberCategories": "Medlemskategorier",
  "memberSince": "Medlem siden",
  "membersPerCounty": "Medlemmer per fylke",
  "memberTypes": "Medlemstyper",
  "min": "min",
  "missing": "Mangler",
  "mobile": "Mobil",
  "mobilePhone": "Mobiltelefon",
  "move": "Flytt",
  "moveDown": "Flytt ned",
  "moveUp": "Flytt opp",
  "multicompanyPortalWelcome": "Velkommen til Flerbedriftsportalen!",
  "municipality": "Kommune",
  "municipalityNumber": "Kommunenummer",
  "name": "Navn",
  "navbar.skipToContent": "Hopp til hovedinnhold",
  "new": "Ny",
  "newAttachment": "Nytt vedlegg",
  "next": "Neste",
  "nextPage": "Neste side",
  "nextYear": "Neste år",
  "no": "Nei",
  "noAccess": "Ingen adgang",
  "noAccessExplanation": "Du har ikke adgang til denne siden. Vennligst gå tilbake til forsiden eller velg noe annet i menyen.",
  "noAttachments": "Ingen vedlegg",
  "noChangePermissions": "Du har ikke tillatelse til å gjøre endringer.",
  "noHits": "Ingen treff",
  "nonCounting": "Ikke tellende",
  "none": "Ingen",
  "note": "Notat",
  "opensInNewTab": "Åpnes i ny fane",
  "notVisible_plural": "Ikke synlige",
  "numberOfEmployees": "Antall ansatte",
  "numberOfHours": "Antall timer",
  "numberOfMinutes": "Antall minutter",
  "numberOfParticipants": "Antall deltakere",
  "of": "av",
  "ofTotal": "av totalt",
  "OK": "OK",
  "old": "Gammel",
  "oldestToNewest": "Eldste til nyeste",
  "ongoing": "Pågående",
  "operationResultListDescription": "{{ success }} ble fullført, og {{ errors }} feilet. Vil du se detaljer?",
  "optional": "valgfritt",
  "optionalCapitalized": "Valgfritt",
  "organizationNumber": "Organisasjonsnummer",
  "orgNr": "Org nr.",
  "other": "Annen",
  "overview": "Oversikt",
  "participants": "Deltagere",
  "participatingCompany": "Deltakerbedrift",
  "pendingApproval": "Trenger godkjenning",
  "phase": "Fase",
  "piece": "stykk",
  "piece_plural": "stykker",
  "postalCity": "Poststed",
  "previous": "Forrige",
  "previousPage": "Forrige side",
  "previousYear": "Forrige år",
  "project": "Prosjekt",
  "project_one": "Prosjekt",
  "project_other": "Prosjekter",
  "projectTypes": "Prosjekttyper",
  "readTerms": "Jeg har lest vilkår for bruk og personvern",
  "reason": "Grunn",
  "recommend": "Anbefal",
  "recommendedCourses": "Anbefalte kurs for medlemmer",
  "register": "Registrer",
  "registration": "Registrering",
  "registrationLink": "Registreringslink",
  "remove": "Fjern",
  "removeRow": "Fjern linje",
  "removeSelected": "Fjern markert utvalg",
  "reopen": "Gjenåpne",
  "reply": "Svar",
  "reports": "Rapporter",
  "reset": "Tilbakestill",
  "responsibility": "Ansvarsområde",
  "responsible": "Ansvarlig",
  "result": "Resultat",
  "retiermentDate": "Utmeldingsdato",
  "role": "Rolle",
  "roles": "Roller",
  "row": "Rad",
  "rowSelected": "Rad valgt",
  "row_plural": "Rader",
  "rowsPerPage": "Rader per side",
  "rowsSelected": "Rader valgt",
  "save": "Lagre",
  "saveAsPdf": "Lagre som PDF",
  "saving": "Lagrer...",
  "search": "Søk",
  "searchEmail": "Søk e-post",
  "searchForActor": "Søk etter aktør",
  "searchMobile": "Søk mobil",
  "searchName": "Søk navn",
  "searchNumberOfParticipants": "Søk antall deltakere",
  "searchTelephone": "Søk telefon",
  "seeAll": "Se alle",
  "seeAllCompCenter": "Se alle i Kompetansesenteret",
  "seeMoreStats": "Se mer statistikk",
  "select": "Velg",
  "selectColumns": "Velg kolonner",
  "selectLanguage": "Velg språk",
  "selectYear": "Velg år",
  "send": "Send",
  "sendEmail": "Send e-post",
  "sent": "Sendt",
  "sentBack": "Sendt tilbake",
  "sessionExipredDescription": "Din sesjon er utløpt, for å få tilgang til portalen igjen, må du logge inn på nytt.",
  "sessionExipredTitle": "Din sesjon er utløpt!",
  "shortCuts": "Snarveier",
  "shortcuts": "Snarveier",
  "show": "Vis",
  "showAll": "Vis alle",
  "showAllColumns": "Vis alle kolonner",
  "showDetails.hide": "Skjul detaljer",
  "showDetails.show": "Vis detaljer",
  "showEmailToggle.hide": "Skjul e-post",
  "showEmailToggle.show": "Vis e-post",
  "showFailed": "Vis feil",
  "showMore": "Vis mer",
  "showOnlySelected": "Vis bare valgte",
  "showSucceeded": "Vis fullførte",
  "startCourse": "Start kurs",
  "startDate": "Startdato",
  "startup": "Oppstart",
  "statistics": "Statistikk",
  "statistics.noData": "Ingen data",
  "status": "Status",
  "submit": "Send inn",
  "sum": "Sum",
  "summary": "Sammendrag",
  "surname": "Etternavn",
  "tasks": "Oppgaver",
  "telephone": "Telefon",
  "termsMustBeAccepted": "Beklager, du må godkjenne brukervilkårene for å kunne logge inn i Flerbedriftsportalen.",
  "termsOfUse": "Brukeravtale for Flerbedriftsportalen",
  "timeRate": "Timesats",
  "to": "Til",
  "toEnterYouMustApprove": "For å komme inn i flerbedriftsportalen må du godkjenne",
  "toFrontpage": "Til forsiden",
  "releaseNotes": "Nytt i Flerbedriftsportalen",
  "releaseNotes.useful": "Nyttig",
  "releaseNotes.voted": "stemte nyttig",
  "releaseNotes.seeAll": "Se alle nytt",
  "total": "Total",
  "type": "Type",
  "unspecified": "Uspesifisert",
  "unsubscribe": "Meld ut",
  "unsubscribed": "Utmeldt",
  "uploadFile": "Last opp fil",
  "userActivation.activationHeader": "Velkommen!",
  "userActivation.activationLoader": "Aktivterer portalinvitasjon. Vennligst vent...",
  "userActivation.activationLoginRequest": "For å godta invitasjonen ber vi deg logge inn gjennom id-porten.",
  "userActivation.activationTextDescription": "Flerbedriftsportalen er en plattform som tilbys klynger og nettverk. ",
  "userActivation.activationTextInvitation": "Du har blitt invitert til Flerbedriftsportalen til Innovasjon Norge.",
  "userActivation.errorHeader": "Aktivering feilet.",
  "userActivation.errorText": "Dette kan være på grunn av ugyldig aktiveringskode eller at du allerede er registrert.",
  "userActivation.title": "Brukeraktivering",
  "visible": "Synlige",
  "visible_plural": "Synlige",
  "website": "Nettsted",
  "withoutName": "Uten navn",
  "writeComplementary": "Skriv utfyllende",
  "writeHere": "Skriv her",
  "writeInDetail": "Skriv utfyllende",
  "writeInDetailMandatory": "Skriv utfyllende (obligatorisk)",
  "year": "År",
  "yes": "Ja",
  "zipCode": "Postnummer",
  "footer.innovasjonNorge.logo.altText": "Innovasjon Norge",
  "footer.declarityOfAvailability": "Tilgjengelighetserklæring",
  "courses.recommendationSent": "Anbefaling sendt!",
  "sending": "Sender...",
  "courses.sendRecommendation": "Send anbefaling",
  "courses.recommendCourse": "Anbefal kurs",
  "oneWayIn": "Én vei inn",
  "sivaReporting": "Rapportering til SIVA",
  "contactSupport": "Kontakt brukerstøtte",
  "contactUsByEmail": "Kontakt oss på e-post",
  "howCanWeHelp": "Du kan kontakte oss på følgende e-post:",
  "showLess": "Vis mindre",
  "organization": "Organisasjon",
  "confirmation": "Bekreftelse",
  "and": "og",
  "fromDate": "Fra dato",
  "toDate": "Til dato",
  "december": "Desember",
  "numberOfResults": "{{ resultsCount }} resultater funnet",
  "oneResult": "Ett resultat funnet",
  "noResults": "Søket ga ingen treff. Vennligst prøv å bruke filtre eller et annet søkeord.",
  "actorTypes.cluster": "Klynger",
  "actorTypes.oneWayIn": "Én vei inn",
  "actorTypes.siva": "NH og INK",
  "actorTypes.sivaAdmin": "Siva admin",
  "step": "Steg",
  "companyType": "Selskapsform",
  "naceCode": "Næringskode",
  "ceo": "Daglig leder",
  "monthly": "Månedtlig",
  "weekly": "Ukentlig",
  "never": "Aldri",
  "updateFailed": "Noe gikk galt",
  "notSet": "Ikke satt",
  "accessControl": "Tilgangstyring",
  "addNew": "Legg til ny",
  "registered": "Registrert",
  "notRegistered": "Ikke registrert",
  "notApplicable": "Ikke aktuelt",
  "readMore": "Les mer",
  "readLess": "Les mindre",
  "copied": "Kopiert!",
  "copy": "Kopier",
  "actors": "Aktører",
  "sendResponse": "Send svar",
  "sendResponseAndRefer": "Send svar og gå til henvisning",
  "clusterStatus.OWI_ACTOR": "Én vei inn",
  "clusterStatus.INCUBATOR": "Inkubator",
  "clusterStatus.BUSINESS_GARDEN": "Næringshage",
  "clusterStatus.NIC_KLYNGE_2025": "Norwegian Innovation Cluster",
  "editTableView.tooltip": "Velg hvilke kolonner som skal \nvises i tabellen, og sett \nrekkefølgen på dem.",
  "draft": "Utkast",
  "emailSent": "E-post sendt",
  "emailSentDetails": "E-posten ble sendt til {{ email }}",
  "emailNotSent": "E-post ble ikke sendt",
  "by": "Av",
  "seeMore": "Se mer",
  "seeLess": "Se mindre",
  "bold": "Fet",
  "italic": "Kursiv",
  "underline": "Understreket",
  "unorderedList": "Punktliste",
  "orderedList": "Nummerert liste",
  "getInContact": "Ta kontakt",
  "toTheTop": "Til toppen",
  "needHelp": "Trenger du hjelp?",
  "subject": "Emne",
  "allInvoices": "Alle fakturaer",
  "byCompany": "Per bedrift",
  "invoicesAreReadyForImport": "Fakturaer er klar til import. Gjennomfør import med knappen nedenfor.",
  "invoicesImportedSuccessfully": "Fakturaer importert suksessfullt.",
  "allYears": "Alle år",
  "siva": "NH og INK",
  "norwegianinnovationclusters": "Norwegian Innovation Clusters",
  "onewayin": "Én vei inn",
  "unknown": "Ukjent"
}
